import { jsx as t, jsxs as c } from "react/jsx-runtime";
import { tv as a } from "tailwind-variants";
import r from "./IconList.js";
const n = a({
  base: ["flex", "flex-col", "gap-2", "text-lg"],
  variants: {
    isHeadingInline: {
      true: ["block"]
    }
  }
});
function o({ children: e, heading: s, isHeadingInline: l = !0 }) {
  return /* @__PURE__ */ t(
    r.Item,
    {
      icon: {
        className: "text-blue-500",
        name: "circle-check",
        style: "solid"
      },
      children: /* @__PURE__ */ c("span", { className: n({ isHeadingInline: l }), children: [
        s && /* @__PURE__ */ c("span", { className: "font-semibold text-blue-500", children: [
          s,
          l && ":"
        ] }),
        " ",
        /* @__PURE__ */ t("span", { className: "text-neutral-500", children: e })
      ] })
    }
  );
}
function m({ ...e }) {
  return /* @__PURE__ */ t(r, { ...e });
}
m.Item = o;
export {
  m as default
};
